import React, { useEffect, useState } from "react";
import { ctbChatService } from "../../services/ctbChatService";
import Chat from "./Chat";
import { useTranslation } from "react-i18next";

export default function CTBChat({loggedUserName}) {
    const { t } = useTranslation();
    const [isActive, setIsActive] = useState(true);

    const checkIsActive = async () => {
        try {
            setIsActive(await ctbChatService.active());
        } catch (err) {
            setIsActive(false);
        }

        setIsActive(true);
    };

    const checkIsHealthy = async () => {
        try {
            return await ctbChatService.health();
        } catch {
            return false;
        }
    };

    useEffect(() => {
        checkIsActive();
    }, []);

    return isActive && (
        <Chat
            title={t("ctb-chat.title")}
            welcomeMessage={t("ctb-chat.messages.welcome")}
            inputPlaceholder={t("ctb-chat.placeholder")}
            loggedUserName={loggedUserName}
            checkIsHealthy={checkIsHealthy}
        />
    );
}